import "core-js/modules/es.array.concat.js";
import { defineComponent, computed } from 'vue';
import { domains } from '@/utils';
export default defineComponent({
  props: {
    creation: {
      type: Object,
      required: true
    }
  },
  setup: function setup(props) {
    var iframeUrl = computed(function () {
      if (props.creation) {
        var cover = props.creation.userCreationCover;
        var sb3 = props.creation.userCreation;

        if (!(sb3.indexOf('//') === 0 || sb3.indexOf('http') === 0)) {
          sb3 = '/' + sb3;
        }

        return "".concat(domains.contestIdeDomain, "/scratchide/#/pcPlayer?url=").concat(sb3, "&cover=").concat(cover);
      }

      return '';
    });
    return {
      iframeUrl: iframeUrl
    };
  }
});